import { firstValueFrom } from 'rxjs';
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sales',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, AfterViewInit {
  @ViewChild('changePasswordModal') changePasswordModal: ElementRef | any;
  @ViewChild('modalFirstAccess') modalFirstAccess: ElementRef | any;

  public errorMessage: string = '';
  public novaSenha: string = '';
  public confirmarNovaSenha: string = '';
  chartOptions: any;
  service: any;
  term: any;
  public isQRCodeChecked: boolean = false;

  manualCode: string = '';
  qrCode: string = '';
  validationCode: string = '';

  constructor(
    public authService: AuthService,
    private modalService: NgbModal,
    public router: Router
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (this.authService.needChange2FA()) {
      this.authService.changeSecurityStep('SET_2FA', true);
    }
    if (this.authService.needChangePassword()) {
      this.modalService.open(this.changePasswordModal, {
        backdrop: 'static',
        keyboard: false,
        centered: true,
        size: 'sm',
      });
    }
  }

  async changePassword() {
    if (this.novaSenha !== this.confirmarNovaSenha) {
      this.errorMessage = 'Senhas não coincidem!';
      return;
    } else if (this.novaSenha.length < 8) {
      this.errorMessage = 'A senha precisa ter no mínimo 8 caracteres';
      return;
    } else {
      this.errorMessage = '';
      await firstValueFrom(
        this.authService.updatePassword(this.novaSenha)
      ).then((result) => {
        if (result.success) {
          this.authService.changeSecurityStep('SET_PASSWORD', true);
          this.modalService.open(this.modalFirstAccess, {
            backdrop: 'static',
            keyboard: false,
            centered: true,
            size: 'sm',
          });
        } else {
          this.errorMessage = 'Erro ao alterar senha!';
        }
      });
    }
  }
  resetLogin() {
    this.modalService.dismissAll();
    this.authService.revokeToken();
    this.authService.clearStorage();
    this.router.navigate(['auth/login']);
  }
}
